import FleetLoadConfirmationActionTypes from './types';
const initialLoadConfirmationData = {
  laneName: '',
  tokenAmount: '',
};

const defaultState = {
  paymentDetails: { ...initialLoadConfirmationData },
  isFetching: false,
  demandDetails: {},
  status: '',
  tripId: NaN,
  errorText: '',
  paymentStatus: {},
  paymentData: '',
  tokenDetails: {},
  walletBalance: {
    balanceInPaisa: 0,
    active: true,
  },
  walletRechargeSource: 'RAZORPAY',
  showPopUp: false,
  vehicleNumberDetail: null,
  vehicleKycDetail: null,
  vehicleKycDetailFetch: null,
  tokenStatus: '',
  contactInfo: {
    driverName: '',
    driverNumber: '',
  },
};

const fleetLoadConfirmationReducer = (
  state: any = defaultState,
  action: { type: string; payload: any; response: any },
) => {
  switch (action.type) {
    case FleetLoadConfirmationActionTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_START: {
      return {
        ...state,
        isFetching: true,
        demandDetails: {},
        status: '',
        errorText: '',
        paymentStatus: '',
        paymentData: {},
      };
    }
    case FleetLoadConfirmationActionTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_SUCCESS: {
      const listData = action.payload?.data?.data || [];
      let newListObj: any = {};
      newListObj = { ...state.paymentDetails };
      newListObj.laneName = listData?.laneName;
      newListObj.tokenAmount = listData?.tokenAmount;
      return {
        ...state,
        paymentDetails: newListObj,
        status: listData.status,
        opQuote: listData.opQuote,
        isFetching: false,
      };
    }

    case FleetLoadConfirmationActionTypes.FETCH_FLEET_LOAD_CONFIRMATION_DETAILS_FAILURE: {
      return { ...state, isFetching: false };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_START: {
      return {
        ...state,
        isFetching: true,
        demandDetails: {},
        errorText: '',
        paymentStatus: '',
        paymentData: {},
      };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_SUCCESS: {
      const data = action.payload;
      let newListObj: any = {};
      newListObj = { ...state };
      newListObj.demandDetails = data;

      return { ...state, isFetching: false, demandDetails: action.payload };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_FLEET_LOAD_CONFIRMATION_PAYMENT_FAILURE: {
      return { ...state, isFetching: false, errorText: action.payload.response.data.message };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_PAYMENT_STATUS_START: {
      return {
        ...state,
        isFetching: true,
        paymentStatus: {},
        demandDetails: {},
        status: '',
        errorText: '',
        paymentData: {},
      };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_PAYMENT_STATUS_SUCCESS: {
      const data = action.payload;
      let newListObj: any = {};
      newListObj = { ...state };
      newListObj.demandDetails = data;
      return {
        ...state,
        isFetching: false,
        status: data.data.status,
        paymentStatus: newListObj,
      };
    }

    case FleetLoadConfirmationActionTypes.INITIATE_PAYMENT_STATUS_FAILURE: {
      return { ...state, isFetching: false, errorText: action.payload.response.data.message, paymentStatus: {} };
    }
    case FleetLoadConfirmationActionTypes.TOKEN_DETAIL: {
      return {
        ...state,
        isFetching: true,
        tokenDetails: {},
      };
    }
    case FleetLoadConfirmationActionTypes.TOKEN_DETAIL_SUCCESS: {
      return {
        ...state,
        tokenDetails: action.payload,
        isFetching: false,
        status: action.payload.status,
        tripId: action.payload?.tripId,
      };
    }
    case FleetLoadConfirmationActionTypes.TOKEN_DETAIL_FAILURE: {
      return {
        ...state,
        tokenDetails: {},
      };
    }
    case FleetLoadConfirmationActionTypes.RESET_TOKEN_DETAIL: {
      return {
        ...state,
        tokenDetails: {},
        tokenStatus: '',
      };
    }
    case FleetLoadConfirmationActionTypes.GET_BALANCE_SUCCESS: {
      return {
        ...state,
        walletBalance: action.payload,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_BALANCE_FAILURE: {
      return {
        ...state,
      };
    }
    case FleetLoadConfirmationActionTypes.CONFIRM_DEMAND_FAILURE: {
      return {
        ...state,
        showPopUp: false,
      };
    }
    case FleetLoadConfirmationActionTypes.CONFIRM_DEMAND_SUCCESS: {
      return {
        ...state,
        status: action.payload.status,
        showPopUp: true,
      };
    }

    case FleetLoadConfirmationActionTypes.FETCH_CONTACT_INFO_SUCCESS: {
      return {
        ...state,
        contactInfo: action.payload,
      };
    }
    case FleetLoadConfirmationActionTypes.FETCH_CONTACT_INFO_FAILURE: {
      return {
        ...state,
        contactInfo: null,
      };
    }

    case FleetLoadConfirmationActionTypes.PAY_TOKEN_SUCCESS: {
      return {
        ...state,
        tokenStatus: action.payload,
        status: action.payload,
      };
    }
    case FleetLoadConfirmationActionTypes.PAY_TOKEN_FAILURE: {
      return {
        ...state,
        tokenStatus: 'FAILED',
      };
    }
    case FleetLoadConfirmationActionTypes.MP_APP_CONFIG_SUCCESS: {
      return {
        ...state,
        walletRechargeSource: action.payload,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_VEHICLE_NUMBER_DETAIL_START: {
      return {
        ...state,
        vehicleNumberDetail: null,
        vehicleProximityWarning: false,
        loadingTimeRemaining: 0,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_VEHICLE_NUMBER_DETAIL_SUCCESS: {
      return {
        ...state,
        vehicleNumberDetail: action.payload.vehicles,
        vehicleProximityWarning: action.payload.vehicleProximityWarning,
        loadingTimeRemaining: action.payload.loadingTimeRemaining,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_VEHICLE_NUMBER_DETAIL_FAILURE: {
      return {
        ...state,
        vehicleNumberDetail: null,
        vehicleProximityWarning: false,
        loadingTimeRemaining: 0,
      };
    }

    //new

    case FleetLoadConfirmationActionTypes.GET_VEHICLE_KYC_DETAIL_START: {
      return {
        ...state,
        vehicleKycDetail: null,
        vehicleKycDetailFetch: true,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_VEHICLE_KYC_DETAIL_SUCCESS: {
      return {
        ...state,
        vehicleKycDetail: action.payload,
        vehicleKycDetailFetch: false,
      };
    }
    case FleetLoadConfirmationActionTypes.GET_VEHICLE_KYC_DETAIL_FAILURE: {
      return {
        ...state,
        vehicleKycDetail: null,
        vehicleKycDetailFetch: false,
      };
    }
    case FleetLoadConfirmationActionTypes.RESET_VEHICLE_KYC_DETAIL: {
      return {
        ...state,
        vehicleKycDetail: null,
        vehicleKycDetailFetch: false,
      };
    }

    default:
      return { ...state };
  }
};

export default fleetLoadConfirmationReducer;
